import { Moment } from 'moment/moment'

import { ConfigItem, DefaultFile } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum TaxExemptionBasicFields {
	id = 'id',
	company = 'company',
	isActive = 'isActive',
	issueDate = 'issueDate',
	serviceSite = 'serviceSite',
	certificateNumber = 'certificateNumber'
}

export enum TaxExemptionDetailedFields {
	document = 'document',
	description = 'description'
}

export enum TaxExemptionSearchFields {
	searchResultByCompanyName = 'searchResultByCompanyName',
	searchResultByServiceSiteId = 'searchResultByServiceSiteId',
	searchResultByServiceSiteName = 'searchResultByServiceSiteName',
	searchResultByCertificateNumber = 'searchResultByCertificateNumber'
}

export enum TaxExemptionFilterFields {
	includeInactive = 'includeInactive'
}

export enum TaxExemptionFormField {
	file = 'file',
	isActive = 'isActive',
	issueDate = 'issueDate',
	serviceSite = 'serviceSite',
	description = 'description',
	certificateNumber = 'certificateNumber'
}

export declare namespace TaxExemption {
	interface Basic {
		[TaxExemptionBasicFields.id]: number
		[TaxExemptionBasicFields.company]: Entity[] | null
		[TaxExemptionBasicFields.isActive]: boolean
		[TaxExemptionBasicFields.issueDate]: BasicString
		[TaxExemptionBasicFields.serviceSite]: Entity | null
		[TaxExemptionBasicFields.certificateNumber]: BasicString
	}

	interface Detailed extends Basic {
		[TaxExemptionDetailedFields.document]: Entity | null
		[TaxExemptionDetailedFields.description]: BasicString
	}

	namespace Search {
		interface Config {
			[TaxExemptionSearchFields.searchResultByCompanyName]: ConfigItem<TaxExemptionSearchFields>
			[TaxExemptionSearchFields.searchResultByServiceSiteId]: ConfigItem<TaxExemptionSearchFields>
			[TaxExemptionSearchFields.searchResultByServiceSiteName]: ConfigItem<TaxExemptionSearchFields>
			[TaxExemptionSearchFields.searchResultByCertificateNumber]: ConfigItem<TaxExemptionSearchFields>
		}
		interface Result {
			[TaxExemptionSearchFields.searchResultByCompanyName]: Entity[] | null
			[TaxExemptionSearchFields.searchResultByServiceSiteId]: Entity[] | null
			[TaxExemptionSearchFields.searchResultByServiceSiteName]: Entity[] | null
			[TaxExemptionSearchFields.searchResultByCertificateNumber]: Entity[] | null
		}
	}

	namespace Filter {
		interface Config {
			[TaxExemptionFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
		}
	}

	interface Request {
		certificateNumber: string
		issueDate: string
		isActive: boolean
		serviceSiteId: number
		description: BasicString
		document: File
	}

	namespace Form {
		interface Basic {
			[TaxExemptionFormField.file]: DefaultFile | null
			[TaxExemptionFormField.isActive]: boolean
			[TaxExemptionFormField.issueDate]: Moment | null
			[TaxExemptionFormField.serviceSite]: LabelValue | null
			[TaxExemptionFormField.description]: BasicString
			[TaxExemptionFormField.certificateNumber]: BasicString
		}

		interface Valid extends Basic {
			[TaxExemptionFormField.file]: DefaultFile
			[TaxExemptionFormField.issueDate]: Moment
			[TaxExemptionFormField.serviceSite]: LabelValue
			[TaxExemptionFormField.certificateNumber]: NonNullable<BasicString>
		}
	}
}
